module.exports = __webpack_public_path__ + "static/media/social-media.fc6a35eb.png";